<template>
  <vxe-modal
    ref="xModal"
    v-model="isShow"
    title="需求详细设计"
    :width="modalWidth"
    :height="modalHeight"
    :mask="showMask"
    :lockView="false"
    :lock-scroll="false"
  >
    <template #header>
      <span>需求详细设计</span>
      <i title="最小化" v-if="!isMini" class="vxe-modal--min-btn trigger--btn vxe-icon--minus" @click="modalToMini"></i>
      <i title="还原" v-else class="vxe-modal--min-btn trigger--btn vxe-icon--zoomout" @click="modalToOriginal"></i>
      <i title="关闭" class="vxe-modal--close-btn trigger--btn vxe-icon--close" @click="closeModal"></i>
    </template>

    <template #default>
      <!-- 编辑区域 -->
      <div class="edit-dv">
        <el-form :model="form" ref="FormRef" :validate-on-rule-change="false" :rules="rules" size="small">
          <!-- 第一行 -->
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="产品类型" prop="productionType">
                <el-input
                  v-model="form.productionType"
                  autocomplete="off"
                  :placeholder="placeholderConfig.relation"
                  :disabled="true"
                ></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="页面" prop="vuePath">
                <!-- <el-select
                  clearable
                  v-model="form.vuePath"
                  :disabled="
                    !!form.content &&
                      (!oldForm || (oldForm && oldForm.content ? form.content !== oldForm.content : false))
                  "
                  :placeholder="messageConfig.selectPlaceholder"
                  filterable
                >
                  <el-option
                    v-for="(i, index) of combobox.vuePath"
                    :key="i + index + ''"
                    :label="i"
                    :value="i"
                  ></el-option>
                </el-select> -->
                <el-autocomplete
                  v-model="form.vuePath"
                  :fetch-suggestions="querySearchVuePath"
                  :placeholder="placeholderConfig.input"
                  @select="getHistoryFun"
                  @change="getHistoryFun"
                  :disabled="
                    (!!oldForm && !!oldForm.content) ||
                      (!!form.content &&
                        (!oldForm || (!!oldForm && !!oldForm.content ? form.content !== oldForm.content : false)))
                  "
                ></el-autocomplete>
                <!-- <el-input
                  v-model="form.vuePath"
                  autocomplete="off"
                  :placeholder="messageConfig.selectPlaceholder"
                  :disabled="
                    !!form.content &&
                      (!oldForm || (oldForm && oldForm.content ? form.content !== oldForm.content : false))
                  "
                ></el-input> -->
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="详设类型" prop="designType">
                <el-select clearable v-model="form.designType" :placeholder="messageConfig.selectPlaceholder" disabled>
                  <el-option label="前端" value="前端"></el-option>
                  <el-option label="后端" value="后端"></el-option>
                </el-select>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="工作量" prop="workTime">
                <el-input v-model="form.workTime" autocomplete="off" :placeholder="placeholderConfig.input"></el-input>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col> -->
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="功能点" prop="functionPoint">
                <!-- <el-input
                v-model="form.functionPoint"
                autocomplete="off"
                :placeholder="placeholderConfig.input"
              ></el-input> -->
                <el-autocomplete
                  v-model="form.functionPoint"
                  :fetch-suggestions="querySearch"
                  :placeholder="placeholderConfig.input"
                  @select="handleSelect"
                  @input="handleInput"
                  :disabled="
                    !!form.content &&
                      (!oldForm || (oldForm && oldForm.content ? form.content !== oldForm.content : false))
                  "
                ></el-autocomplete>
                <template slot="error" slot-scope="slot">
                  <errorTooltip :content="slot.error"></errorTooltip>
                </template>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row v-show="form.functionPoint">
            <el-col :span="!hasOldForm || ifCloseDiff ? 24 : 12">
              <div class="richEditorContainer">
                <YKDivider>
                  <div style=" display: flex; justify-content: space-between; align-items: center">
                    <div>详设内容</div>
                    <div style="padding-right: 8px">
                      <el-button size="mini" type="danger" icon="el-icon-delete" @click="handleClearContent">
                        清空内容
                      </el-button>
                    </div>
                  </div>
                </YKDivider>
                <!-- <YKEditor ref="YKEditor" v-model="form.content" :editorHeight="editorHeight"></YKEditor> -->
                <div style="margin-top: 10px">
                  <YKEditorV2 ref="YKEditorV2Ref" v-model="form.content" :height="editorHeight" />
                </div>
                <div class="zoomBtn" v-if="hasOldForm" @click="hanldeDiffContainer">
                  <i v-if="ifCloseDiff" class="vxe-icon--arrow-left"></i>
                  <i v-else class="vxe-icon--arrow-right"></i>
                </div>
              </div>
            </el-col>
            <el-col :span="!hasOldForm || ifCloseDiff ? 0 : 12">
              <YKDivider>与上个版本的差异</YKDivider>
              <div class="diffContainer" :style="{ height: diffContainerHeight }">
                <DiffComponent
                  v-if="oldForm && oldForm.content"
                  :oldContent="oldForm.content"
                  :newContent="form.content"
                ></DiffComponent>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <!-- 间隔槽（内含保存按钮） -->
      <div class="gap-dv">
        <el-button
          size="small"
          type="primary"
          style="width: 150px"
          :disabled="!$parent.Authority.edit"
          @click="commitDesign()"
        >
          保存
        </el-button>
        <!-- <el-button size="small" type="success" style="width: 150px" @click="searchDiff()">
        查看版本差异
      </el-button> -->
      </div>
    </template>
  </vxe-modal>
</template>

<script>
// import YKEditor from '@/components/Editor/YKEditor.vue'
import YKEditorV2 from '@/components/Editor/YKEditorV2.vue'
import DiffComponent from './DiffComponent.vue'
import { debounce } from 'lodash' // 引入lodash的debounce函数

export default {
  name: 'instructionEdit',
  components: {
    // YKEditor,
    YKEditorV2,
    DiffComponent
  },
  props: {
    parentObj: Object,
    // 当前数据行id
    id: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      // 弹窗是否打开
      isShow: false,
      // 旧的form
      oldForm: null,
      form: {
        id: 0,
        ykCaseID: 0,
        productionType: '',
        vuePath: '',
        designType: '',
        functionPoint: '',
        designers: '',
        designContent: '',
        designTime: '',
        content: '',
        workTime: 0
      },
      // 右键行缓存,用于储存缓存数据打开窗口时初始化值
      row: {},
      rules: {
        type: [{ required: true, message: '请选择变更类型', trigger: 'change' }],
        content: [
          {
            min: 0,
            max: 1000,
            message: '长度应在 0 到 1000 个字符',
            trigger: 'change'
          }
        ],
        designComment: [
          { required: true, message: '请输入变更内容', trigger: 'change' },
          {
            min: 0,
            max: 1000,
            message: '长度应在 0 到 1000 个字符',
            trigger: 'change'
          }
        ]
      },
      // 特殊权限
      spcial: false,
      frontEngineerCache: '',
      backEngineerCache: '',
      techTesterCache: '',
      businessTesterCache: '',
      // 下拉框列表
      combobox: {
        // 说明类型
        result: [],
        vuePath: []
      },
      // 历史说明列表
      historyInsList: [
        // {
        //   type: '提出',
        //   date: '2021-12-20 08:28',
        //   user: '张三',
        //   instruction: '前端处理人修改为李四'
        // },
      ],
      selectOptions: {
        frontEngineer: [],
        backEngineer: [],
        techTester: [],
        businessTester: [],
        type: ['前端', '后端', '数据库']
      },
      historyFunctionPoint: [],
      allHistoryFunctionPoint: [],
      minWidth: '187px',
      minHeight: '38px',
      modalWidth: '100%',
      modalHeight: '100%',
      showMask: false,
      isMini: false,
      // 收缩
      ifCloseDiff: false,
      // 获取历史数据的key
      getHistoryFunctionPointKey: 'getHistoryFunctionPointKey',
      debouncedHandleInput: null, // 用于存储防抖后的handleInput函数
      // 需要刷新页面选择
      needRefresh: true
    }
  },

  methods: {
    // 清空内容
    handleClearContent() {
      this.form.content = ''
    },
    // 显示/隐藏 diff容器
    hanldeDiffContainer() {
      this.ifCloseDiff = !this.ifCloseDiff
    },
    // 还原窗体
    modalToOriginal() {
      this.isMini = false

      this.modalWidth = '100%'
      this.modalHeight = '100%'
      this.$refs.xModal.setPosition(0, 0)
    },
    // 最小化窗体
    modalToMini() {
      this.isMini = true

      this.modalWidth = this.minWidth
      this.modalHeight = this.minHeight
      // this.showMask = false
      this.$refs.xModal.setPosition(this.$store.state.clientHeight - 38, 0)
    },
    // 查看差异
    searchDiff() {
      const beforeForm = {
        id: 0,
        ykCaseID: 0,
        productionType: '铁塔',
        vuePath: '原材料库存',
        designType: '前端',
        functionPoint: '',
        designers: '',
        designContent: '',
        designTime: '',
        content:
          '<h4>3. 用户界面2设计</h4><ul><li><strong>添加到购物车按钮</strong>：每个商品旁边有一个“添加到购物车”按钮。</li><li><strong>购物车图标</strong>：页面右上角有一个购物车图标，显示当前购物车中的商品数量。</li><li><strong>购物车页面</strong>：</li><li class="ql-indent-1">商品列表：显示商品名称、图片、单价、数量选择器和每个商品的小计。</li><li class="ql-indent-1">更新按钮：允许用户更新购物车中的商品数量。</li><li class="ql-indent-1">移除按钮：允许用户从购物车中移除商品。</li><li class="ql-indent-1">总价显示：显示购物车中所有商品的总价。</li><li class="ql-indent-1">结账按钮：允许用户进行结账操作。</li></ul><p><img src="http://localhost:8080/testUploadApi/downloadnew/------WebKitFormBoundaryYuRBLNZuP79LrR1A--/1727091154864_8e5f55589cf7f4a5259e414d7f22a4e2.png"></p>'
      }

      const afterForm = {
        id: 0,
        ykCaseID: 0,
        productionType: '铁塔',
        vuePath: '原材料库存',
        designType: '前端',
        functionPoint: '',
        designers: '',
        designContent: '',
        designTime: '',
        content:
          '<h4>3. 用户界面3设计</h4><ul><li><strong>添加到购物222车按钮</strong>：每个商品旁边有一个“添加到购物车”按钮。</li><li><strong>购物车图标</strong>：页面右上角有一个购物车图标，显示当前购物车中的商品数量。</li><li><strong>购物车页面</strong>：</li><li class="ql-indent-1">商品列表：显示商品名称、图片、单价、数量选择器和每个商品的小计。</li><li class="ql-indent-1">更新按钮：允许用户更新购物车中的商品数量。</li><li class="ql-indent-1">移除按钮：允许用户从购物车</li><li class="ql-indent-1">总价显示：显示购物车中所有商品的总价。</li></ul><p>结账按钮：允许用户进行结账操作。</p><p><img src="http://localhost:8080/testUploadApi/downloadnew/------WebKitFormBoundaryXPjNiB1gyebYABBO--/1727091212810_16f079542dc40d897753761e6f223de5.png"></p>'
      }

      this.$refs.DiffModalRef.openModal(beforeForm.content, afterForm.content)
    },
    // 快速输入
    async querySearch(queryString, cb) {
      let results = []

      if (queryString) {
        const res = await this.sureGetHistoryContent(queryString)
        results = res.map(i => {
          return {
            value: i
          }
        })
      } else {
        results = this.allHistoryFunctionPoint
      }

      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 快速输入
    async querySearchVuePath(queryString, cb) {
      let results = []

      if (queryString) {
        results = this.combobox.vuePath.filter(i => i.value.includes(queryString))
        // 将结果和queryString相等的放在最前面
        results = results.sort((a, b) => {
          return a.value === queryString ? -1 : b.value === queryString ? 1 : 0
        })
      } else {
        results = this.combobox.vuePath.slice(0, 20)
      }

      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    // 选择后
    handleSelect(item) {
      this.oldForm = null
      this.debouncedHandleInput(item.value)
    },
    // 输入内容
    handleInput(item) {
      this.oldForm = null
      this.debouncedHandleInput(item)
    },
    // 调接口获取历史记录
    async sureGetHistoryContent(item) {
      const { data: res } = await this.$http.post(
        '/Common/YKDetailDesign/prompt',
        {
          promptType: 'FunctionPoint',
          productionType: this.form.productionType,
          vuePath: this.form.vuePath,
          designType: this.form.designType,
          functionPoint: item
        },
        {
          headers: {
            loading: false
          }
        }
      )
      if (!res.isSuccess) {
        return []
      }

      return res.data
    },
    async getPointDetail(item) {
      this.form.content = ''

      if (!item) {
        this.oldForm = null
        return
      }

      // if (!item || !this.historyFunctionPoint.includes(item)) {
      //   return false
      // }
      // 获取明细
      const { data: res } = await this.$http.post('/Common/YKDetailDesign/list', {
        productionType: this.form.productionType,
        vuePath: this.form.vuePath,
        designType: this.form.designType,
        functionPointExact: item,
        pageIndex: 1,
        pageSize: 1
      })
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }
      if (res.data?.rows?.length > 0) {
        this.oldForm = res.data.rows[0]

        this.form.content = this.oldForm.content
      }
    },
    // 提交变更
    async commitDesign() {
      this.form.designTime = this.ykDateFormat('yyyy-MM-dd HH:mm:ss', new Date())

      let form = { ...this.form }
      form = this.removeObjectNull(form)

      if (!form.content) {
        this.$message.error('请填写详细设计内容')
        return false
      }

      const { data: res } = await this.$http.post('/Common/YKDetailDesign', form)
      if (!res.isSuccess) {
        this.$message.error(res.errorMessage)
        return false
      }

      this.$message.success('保存成功')
      try {
        await this.$parent.refresh()
      } catch {
        console.error('刷新数据失败')
      }
      this.isShow = false
    },
    // 排版问题内容
    handleTypography() {
      if (this.form.content) {
        let cache = this.form.content + ''
        const separator = cache.substring(1, 2)
        const re = new RegExp('([0-9]{1,3}|1000)' + '\\' + separator, 'g')
        const numList = cache.match(re)
        let resultList = []
        if (numList) {
          for (let i = 0; i < numList.length; i++) {
            // numList[i] = Number(String(numList[i]).split(separator)[0])
            if (i === 0) {
              resultList.push(numList[i])
            } else {
              if (
                Number(numList[i].split(separator)[0]) - 1 ===
                Number(resultList[resultList.length - 1].split(separator)[0])
              ) {
                resultList.push(numList[i])
              }
            }
          }
          // resultList = resultList.map(item => {
          //   return String(item) + separator
          // })
          if (resultList) {
            let isFirst = true
            for (let item of resultList) {
              if (isFirst) {
                isFirst = false
              } else {
                cache = cache.replace(item, '\n' + item)
              }
            }
            this.form.content = cache
          } else {
            this.$message.error('没有内容可以排版')
          }
        } else {
          this.$message.error('没有内容可以排版')
        }
      }
    },
    // 获取历史功能点
    async getHistoryFun(isAll = false) {
      // 获取历史的功能点记录
      const result = await this.sureGetHistoryContent(isAll ? '' : this.form.functionPoint)
      this.allHistoryFunctionPoint = result
        .map(i => {
          return {
            value: i
          }
        })
        .slice(0, 20)
    },
    // 监听模态框开启
    async showModal(row) {
      // 初始化
      const designType = row['frontDesigners'].split('、').includes(this.curUserName) ? '前端' : '后端'

      this.oldForm = null

      this.form = {
        id: 0,
        ykCaseID: row.id,
        productionType: row['menuArgs'],
        vuePath: row['vuePath'],
        designType: designType,
        functionPoint: '',
        designers: designType === '前端' ? row['frontDesigners'] : row['backDesigners'],
        designContent: '',
        designTime: '',
        workTime: 0,
        content: ''
      }

      this.isShow = true

      // 获取下拉框数据
      if (this.needRefresh) {
        this.combobox.vuePath = []
        const { data: res } = await this.$http.post('/Common/YKDetailDesign/select-item', {
          productionType: this.$store.state.productType
        })
        if (!res.isSuccess) {
          this.$message.error(res.errorMessage)
          return false
        }
        let resResult = res.data.map(i => {
          return i.name
        })
        const resultSet = new Set(resResult)
        resResult = Array.from(resultSet)
        this.combobox.vuePath = resResult.map(i => {
          return {
            value: i
          }
        })
      }

      this.getHistoryFun(true)

      // 挂在防抖函数

      // 在created钩子中创建防抖函数
      // 在created钩子中创建防抖函数
      this.debouncedHandleInput = debounce((...args) => {
        this.getPointDetail(...args)
      }, 300) // 300ms的延迟

      this.$nextTick(() => {
        if (this.$refs['FormRef']) {
          this.$refs['FormRef'].clearValidate()
        }
      })
    },
    // 监听模态框关闭
    closeWindows() {
      this.$refs['FormRef'].resetFields()
    },
    // 校验表单
    async validForm() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      if (!flag) {
        this.$message.error('请正确填写信息')
      }
      return flag
    },
    closeModal() {
      this.isShow = false
    }
  },
  computed: {
    // 当前登录用户名
    curUserName() {
      return this.$store.state.userInfo.userName
    },
    editorHeight() {
      return Number(this.$store.state.clientHeight) - 43 - 22 - 78 - 78 - 33 - 40 - 14 - 12
    },
    diffContainerHeight() {
      return Number(this.$store.state.clientHeight) - 43 - 22 - 78 - 78 - 33 - 40 - 14 - 12 + 'px'
    },
    // 是否有旧数据
    hasOldForm() {
      return this.oldForm && this.oldForm.content
    },
    // 当前产品类型
    curProductType() {
      return this.$store.state.productType
    }
  },
  watch: {
    curProductType: {
      handler(newVal, oldVal) {
        // 当产品变化时需要重新获取
        if (newVal !== oldVal) {
          this.needRefresh = true
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@history-dv-height: 200px;
@all-dv-width: 98%;
// 编辑说明和历史说明之间的间隔
@dv-margin: 10px;
// 间隔槽总高度 = 高度 + margin
@gap-margin: 0;
@gap-height: 30px;
@gap-padding-bottom: 10px;
.edit-dv {
  width: @all-dv-width;
  margin: 0 auto;
  height: calc(100% - 42px);
  overflow-y: scroll;
  overflow-x: hidden;
}

.edit-dv::-webkit-scrollbar {
  display: none;
}

.gap-dv {
  position: absolute;
  bottom: 0;
  left: 0;

  width: 100%;
  height: @gap-height;
  margin: @gap-margin 0;
  padding-bottom: @gap-padding-bottom;
  // border-bottom: 1px solid #f2f3f5;
  .fl;

  .btn {
    margin: 0 10px;
    width: 180px;
    height: 30px;
    font-size: 14px;
    border-radius: 5px;
    outline: none;
    border: none;
    transition: @normal-transition;
  }

  > button:hover {
    cursor: pointer;
    opacity: 0.7;
  }

  > button:active {
    opacity: 0.9;
  }

  .save-btn {
    background-color: @primary-color;
    color: @text-color;
  }

  .add-btn {
    width: 100px;
    color: #666;
  }

  .del-btn {
    width: 100px;
    background-color: #ff8b8b;
    color: #fff;
  }
}

.btn-dv-prohibit {
  // cursor: not-allowed;
  transition: none !important;
  opacity: 0.5 !important;
  // color: #c0c4cc;
  // border-color: #ebeef5;
  // background-color: #f2f3f5;
}
.btn-dv-prohibit:hover {
  cursor: not-allowed !important;
  opacity: 0.5 !important;
}

.history-dv {
  width: @all-dv-width;
  height: @history-dv-height;
  margin: 10px auto;
  // background-color: #ffcc66;
  overflow-y: scroll;
  box-sizing: border-box;
  font-size: 14px;

  .scrollbar-mixin();

  .history-title {
    font-size: 16px;
    font-weight: bold;
    color: @able-color;
  }

  .history-list-dv {
    width: 97%;
    padding: @dv-margin auto;

    .history-list-item {
      margin: 6px 0;
    }
  }
}

.el-row {
  margin-bottom: 12px !important;
}

.vxe-modal--min-btn {
  position: absolute;
  right: 40px;
  top: 0.85em;
  z-index: 3;
  cursor: pointer;
}

.diffContainer {
  border: 1px solid #cccccc;
  margin-top: 10px;
  overflow: auto;
}

.richEditorContainer {
  position: relative;

  box-sizing: border-box;
  padding-right: 15px;

  .zoomBtn {
    position: absolute;
    right: 5px;
    top: 50%;
    transform: translate(0, -50%);
    border-radius: 3px;
    width: 15px;
    height: 55px;
    // line-height: 55px;
    // text-align: center;
    box-shadow: 0px 0px 5px #999;

    color: #969696;

    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #d3e3fd;
    transition: all 0.3s;
    cursor: pointer;

    &:hover {
      opacity: 0.7;
    }
  }
}
</style>
